import { takeEvery, put } from 'redux-saga/effects';
import { request } from '../../../api/Service';
import { getErrorMessage } from '../../../components/utils/errorHandler';
import { toast } from 'react-toastify';

export default function* watcherGetSalesReport() {
  yield takeEvery('LOAD_SALES_REPORT', workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: 'DISPLAY_LOADER', payload: payload });
    var payload = {};
    console.log(action.payload)
    var formatUrl = `api/SalesTransactionV2/get-sales-report?startDate=${action.payload.startDate}&endDate=${action.payload.endDate}&userId=${action.payload.userId}`;
    yield request('get', {}, formatUrl).then((response) => {
     payload = response;
   });
  console.log(action.payload)
    yield put({ type: 'SALES_REPORT', payload: payload });
    yield put({ type: 'DISPLAY_LOADER' });
  } catch (e) {
    yield put({ type: 'DISPLAY_LOADER', payload: payload });
    yield put({ type: 'LOADING_BUTTON_SPINNER' });
    console.log('profitabilityReport', e);
    console.log('profitabilityReport', e.response);
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: 'API_ERRORED', payload: e });
  }
}
